import {
  Button,
  Chip,
  Grid,
  makeStyles,
  Typography,
} from "@material-ui/core";
import moment from "moment";
import "moment/locale/es";
import React, { useRef } from "react";
import { useDispatch } from "react-redux";
import { useForm } from "../../../../hooks/useForm";
import BuscadorPractica from "../../convenios/BuscadorPractica";
import { fetchConToken } from "../../../../helpers/fetch";
import { startAlerta } from "../../../../actions/ui/alertas";
import { finishSpinner, startSpinner } from "../../../../actions/ui/spinner";


const useStyles = makeStyles((theme) => ({
  chip: {
    margin: theme.spacing(0.5),
  },
  root: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    listStyle: 'none',
    padding: theme.spacing(0.5),
    margin: 0,
  },
}));

export const FormCosegurosPracticas = (props) => {
  moment.locale("es");
  const { Grupo } = props;

  const codigoPracticaRef = useRef(null);
  const codigoPracticaHastaRef = useRef(null);

  const classes = useStyles()
  const dispatch = useDispatch()

  let initForm = {
    idModulo: "",
    codigoPractica: null,
    codigoPracticaHasta: null,
    practicas: [],
  };

  const [
    formValues,
    ,
    ,
    setearValor,
    ,
    ,
    ,
    ,
    setearVariosValores
  ] = useForm(initForm);

  const {
    practicas,
    codigoPractica,
    codigoPracticaHasta
  } = formValues;

  console.log(practicas);

  const handleAgregarPracticas = async () => {
    try {
      dispatch(startSpinner())
      const result = await fetchConToken(`NomencladorNacional/PracticasSimples/${codigoPractica.codNom}/${codigoPracticaHasta ? codigoPracticaHasta.codNom : codigoPractica.codNom}`)
      const body = await result.json()

      if (result.ok) {
        const bodyFormateado = body?.map((item) => {
          return {
            idPractica: item.idPractica,
            codNom: item.codigoPractica,
            desNom: item.nombrePractica,
            desNomCorta: item.nombrePracticaCortada
          }
        });

        setearVariosValores({
          "practicas": [...practicas, ...bodyFormateado.filter(e => !practicas.includes(e))],
          "codigoPractica": null,
          "codigoPracticaHasta": null
        })
        codigoPracticaRef.current.resetValues();
        codigoPracticaHastaRef.current.resetValues();
        dispatch(finishSpinner())
      } else {
        throw body
      }
    } catch (error) {
      dispatch(finishSpinner())

      dispatch(startAlerta("Error al traer las practicas", "error"))
    }
  }

  const handleSavePract = (e) => {
    e.preventDefault();

    if(practicas.length === 0){
      dispatch(startAlerta("No se incluyó ninguna práctica", "error"))
    } else {
      props.handleSavePractica({ Grupo, idsPracticas: practicas.map((item) => item.idPractica) });
    }

  };

  return (
    // <ValidatorForm onSubmit={handleSavePract}>
    <>
    <Grid container style={{ padding: 25 }}>
        <Grid item xs={10}>
          <Grid container spacing={1}>
            <Grid item xs={5}>
              <BuscadorPractica
                ref={codigoPracticaRef}
                cod={codigoPractica}
                label="Código Practica Desde"
                fieldsDisabled={false}
                setCod={(val) => setearValor("codigoPractica", val)}
              />
            </Grid>
            <Grid item xs={5}>
              <BuscadorPractica
                ref={codigoPracticaHastaRef}
                cod={codigoPracticaHasta}
                label="Código Practica Hasta"
                fieldsDisabled={false}
                setCod={(val) => setearValor("codigoPracticaHasta", val)}
              />
            </Grid>
            <Grid item xs={2} style={{ alignSelf: "center" }}>

              <Button
                onClick={() => {
                  if (codigoPractica !== null) {
                    handleAgregarPracticas()
                  }
                }} type="button" color="primary">
                + Agregar
              </Button>
            </Grid>
          </Grid>

        </Grid>
        <Grid item xs={12}>
          <Typography variant="button">Prácticas agregadas</Typography>
          <div className={classes.root}>
            {
              practicas.map((practica, index) => (
                <Chip
                  key={index}
                  label={practica.codNom + " - " + practica.desNomCorta}
                  onDelete={() => setearValor("practicas", practicas.filter(e => e !== practica))}
                  className={classes.chip}
                />
              ))
            }
          </div>
        </Grid>
      </Grid>
      <div style={{ textAlign: "right", marginTop: "2rem" }}>
        <Button color="primary" onClick={handleSavePract}>
          Aceptar
        </Button>
        <Button onClick={props.handleCloseModal} type="button" color="primary">
          Cancelar
        </Button>


      </div>
    
    </>
   // </ValidatorForm>
  );
};
export default FormCosegurosPracticas;
